import axios from "axios";
import { BASE_URL } from "../misc/Static_routes";
import { toast } from "react-toastify";
import axiosInstance from "../config/axiosConfig";
axios.defaults.withCredentials = true;

const notify = (message) => toast.error(`${message}`, {});
const notifySuccess = (message) => toast.success(`${message}`, {});
const notifyWarning = (message) => toast.warning(`${message}`, {});
const notifyError = (message) => toast.error(`${message}`, {});

export const getAllCategories = () => {
  const result = axios
    .get(`${BASE_URL}/api/admin/categories`)
    .then((response) => {
      const responseOK =
        response && response.status === 200 && response.statusText === "OK";

      if (responseOK) {
        return response.data;
      }
    })
    .catch((error) => {
      console.log("error", error);
    });

  return result;
};

export const createCategory = async (data, t) => {
  const result = axios
    .post(`${BASE_URL}/api/admin/categories`, data)
    .then((response) => {
      const responseOK =
        response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        notifySuccess(t('successfullyCreatedCategory'));
        return response.data;
      } else {
        notifyError(t('errorWhileCreatingCategory'));
      }
    });
    return result;
};

export const deleteCategory = async (data, t) => {
  const result = axios
    .delete(`${BASE_URL}/api/admin/categories`, {data})
    .then((response) => {
        notifySuccess('Successfully deleted category.');
        return response?.data;
    }).catch((err) => notifyError('eAn rror occured while creating category'));
    return result;
};


export const categoryService = {
  getAllCategories: () => axiosInstance.get(`${BASE_URL}/api/admin/categories`).then(res => res?.data?.categories)
}